import { useEffect, useState } from 'react'
// ** Next Import
import { Link, useLocation, useNavigate } from 'react-router-dom'

// ** MUI Imports
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Drawer from '@mui/material/Drawer'
import { styled, useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
// MUI Icons Imports
import MenuIcon from '@mui/icons-material/Menu'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import LogoWhite from 'src/@core/components/logo-white'
import LanguageLOGO from '../../assets/images/language.svg'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Collapse, Dialog, DialogActions, DialogTitle, FormControl, ListItemIcon, ListItemText, Menu, MenuItem, Select
} from '@mui/material'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded'
import LoginRoundedIcon from '@mui/icons-material/LoginRounded'
import { useCurrency } from 'src/context/CurrancyContext'
import CategoriesIcon from 'src/@core/components/icons/CategoriesIcon'
import AgentDirectoryIcon from 'src/@core/components/icons/AgentDirectoryIcon'
import HelpIcon from 'src/@core/components/icons/HelpIcon'
import HomeIcon from 'src/@core/components/icons/HomeIcon'
import BecomeAnAgentIcon from 'src/@core/components/icons/BecomeAgentIcon'
import RegisterLoginIcon from 'src/@core/components/icons/RegisterLoginIcon'
import HowItWorksIcon from 'src/@core/components/icons/HowItWorksIcon'
import SubscriptionIcon from 'src/@core/components/icons/SubscriptionIcon'
import { currencySymbols } from 'src/utils/currencyUtils'
import Translations from './Translations'
import useCustomTranslation from 'src/@core/hooks/useCustomTranslation'
// ** Configs
const AppBarWrapper = styled(AppBar)(({ scroll, location }) => ({
  backgroundColor: location.pathname === '/landing-page' ? (scroll ? '#0e0e0e' : 'transparent') : '#0e0e0e',
  transition: 'background-color 0.3s ease-in-out'
}))

const currencyList = Object.keys(currencySymbols);

const LoginButton = styled(Button)(({ theme, scroll, location }) => ({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '24px',
  borderRadius: '5px',
  border: `1px solid ${theme.palette.tertiary.main}`,
  color: theme.palette.tertiary.main,
  backgroundColor: '#FFFFFF33'
}))
// Update your MuiSelect styled component
const MuiSelect = styled(Select)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  border: 'none',
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none !important'
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 15px',
  },
  color: theme.palette.tertiary.main,
  boxShadow: 'none',
  backgroundColor: 'transparent'
}))

// Add this styled component with your other styled components
const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px 20px',
  '&:hover': {
    color: '#000',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    '& .MuiSvgIcon-root': {
      color: '#FC5722',
    }
  },
  '& .MuiSvgIcon-root': {
    color: '#8F9DAC',
    fontSize: '24px',
  }
}))

const DrawerHeaderWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start'
}));


const PublicLayoutAppBar = ({ settings, saveSettings }) => {
  const theme = useTheme()
  const translation = useCustomTranslation()
  const { i18n, t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [scroll, setScroll] = useState(false)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [open, setOpen] = useState(false)
  const { currency, setCurrency } = useCurrency()
  const [hoverHome, setHoverHome] = useState(false);
  const [hoverCategory, setHoverCategory] = useState(false);
  const [hoverDirectory, setHoverDirectory] = useState(false);
  const [hoverHelp, setHoverHelp] = useState(false);
  const [hoverAgent, setHoverAgent] = useState(false);
  const [hoverRegister, setHoverRegister] = useState(false);
  const [hoverSubscription, setHoverSubscription] = useState(false);
  const [hoverHow, setHoverHow] = useState(false);

  // const handleChangeCurrency = e => {
  //   setCurrency(e.target.value)
  // }
  const handleChangeCurrency = (event) => {
    const newCurrency = event.target.value
    setCurrency(newCurrency)

    // Store the selected currency in localStorage
    localStorage.setItem('selectedCurrency', newCurrency)

    // Optional: You can also dispatch a custom event to notify other components
    window.dispatchEvent(new StorageEvent('storage', {
      key: 'selectedCurrency',
      newValue: newCurrency
    }))
  }
  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = url => {
    setOpen(false)
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  const handleDrawerOpen = () => {
    setOpenDrawer(true)
  }

  const handleDrawerClose = () => {
    setOpenDrawer(false)
  }

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 0)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const [agent, setAgent] = useState('Become an Agent')

  const handleChangeAgent = event => {
    const selectedValue = event.target.value
    setAgent(selectedValue)
    if (selectedValue === 'Subscription Packages') {
      handleMenuClose()
      handleDrawerClose()
      setTimeout(() => {
        navigate('/subscription-page')
      }, 0)
    }
    if (selectedValue === 'How It Works') {
      handleMenuClose()
      handleDrawerClose()
      setTimeout(() => {
        navigate('/how-it-works')
      }, 0)
    }
    if (selectedValue === 'Register/Login') {
      handleClickOpen()
      handleMenuClose()
      handleDrawerClose()
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 0)
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const [openCategory, setOpenCategory] = useState(false)
  const [openServices, setOpenServices] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileMenuAnchorEl, setMobileMenuAnchorEl] = useState(null)

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMobileMenuClick = event => {
    setMobileMenuAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
    setMobileMenuAnchorEl(null)
  }

  const handleCategoryClick = () => {
    setOpenCategory(!openCategory)
  }
  const handleServicesClick = () => {
    setOpenServices(!openServices)
  }

  return (
    <>
      <AppBarWrapper
        elevation={0}
        scroll={scroll}
        location={location}
        position={location.pathname === '/landing-page' ? 'fixed' : 'sticky'}
        sx={{ top: 0 }}
      >
        <Toolbar
          sx={{
            marginInline: { xs: '1rem', sm: '1rem', md: '5rem' },
            minHeight: '90px'
          }}
        >
          <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
            <Box flexGrow={1} display={'flex'} alignItems={'center'}>
              <Link to='landing-page'>
                <LogoWhite width='130' height='50' />
              </Link>
            </Box>
            <Box
              display={{ xs: 'none', sm: 'none', md: 'flex' }}
              alignItems={'center'}
              justifyContent={'space-between'}
              gap={2}
            >
              <List>
                <ListItem>
                  <FormControl fullWidth sx={{ border: 'none' }}>
                    <MuiSelect
                      scroll={scroll}
                      location={location}
                      value={agent}
                      onChange={handleChangeAgent}
                      IconComponent={() => (
                        <KeyboardArrowDownRoundedIcon
                          sx={{
                            fontSize: '20px',
                            color: 'inherit',
                            marginLeft: '-30px',
                            transition: 'transform 0.2s ease-in-out',
                            transform: Boolean(anchorEl) ? 'rotate(180deg)' : 'rotate(0deg)',
                          }}
                        />
                      )}
                    >
                      <StyledMenuItem
                        value={'Become an Agent'}
                        sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}
                        onMouseEnter={() => setHoverAgent(true)}
                        onMouseLeave={() => setHoverAgent(false)}
                        onClick={() => window.open('https://www.agent.oujat.com/login', '_blank', 'noopener,noreferrer')}
                      >
                        <BecomeAnAgentIcon color={hoverAgent ? "#FC5722" : "#8F9DAC"} />
                        <Translations text={translation.translate('PublicLayoutAppBar.Become an Agent')} />
                      </StyledMenuItem>

                      <StyledMenuItem
                        value={'Register/Login'}
                        sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}
                        onMouseEnter={() => setHoverRegister(true)}
                        onMouseLeave={() => setHoverRegister(false)}
                      >
                        <RegisterLoginIcon color={hoverRegister ? "#FC5722" : "#8F9DAC"} />
                        <Translations text={translation.translate('PublicLayoutAppBar.Register/Login')} />
                      </StyledMenuItem>
                      <StyledMenuItem
                        value={'Subscription Packages'}
                        sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}
                        onMouseEnter={() => setHoverSubscription(true)}
                        onMouseLeave={() => setHoverSubscription(false)}
                      >
                        <SubscriptionIcon color={hoverSubscription ? "#FC5722" : "#8F9DAC"} />
                        <Translations text={translation.translate('PublicLayoutAppBar.Subscription Packages')} />
                      </StyledMenuItem>
                      <StyledMenuItem
                        value={'How It Works'}
                        sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}
                        onMouseEnter={() => setHoverHow(true)}
                        onMouseLeave={() => setHoverHow(false)}
                      >
                        <HowItWorksIcon color={hoverHow ? "#FC5722" : "#8F9DAC"} />
                        <Translations text={translation.translate('PublicLayoutAppBar.How It Works')} />
                      </StyledMenuItem>
                    </MuiSelect>
                  </FormControl>
                </ListItem>
              </List>
              <List>
                <ListItem>
                  <FormControl fullWidth sx={{ border: 'none' }}>
                    <MuiSelect
                      scroll={scroll}
                      location={location}
                      displayEmpty
                      value={currency}
                      onChange={handleChangeCurrency}
                      IconComponent={() => (
                        <KeyboardArrowDownRoundedIcon sx={{ fontSize: '20px', color: 'inherit', marginLeft: '-94px' }} />
                      )}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                          },
                        },
                      }}
                    >
                      {currencyList.map((code) => (
                        <MenuItem
                          key={code}
                          value={code}
                          sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}
                        >
                          {code}
                        </MenuItem>
                      ))}
                    </MuiSelect>
                  </FormControl>
                </ListItem>
              </List>
              <List>
                <ListItem>
                  <FormControl fullWidth sx={{ border: 'none' }}>
                    <MuiSelect
                      scroll={scroll}
                      location={location}
                      value={i18n.language}
                      onChange={event => {
                        const lang = event.target.value
                        i18n.changeLanguage(lang)
                        if (lang === 'ar') {
                          saveSettings({ ...settings, direction: 'rtl' })
                        } else {
                          saveSettings({ ...settings, direction: 'ltr' })
                        }
                      }}
                      IconComponent={() => (
                        <KeyboardArrowDownRoundedIcon sx={{ fontSize: '20px', color: 'inherit', marginLeft: '-48px' }} />
                      )}
                      displayEmpty
                      renderValue={selected => {
                        const languageMap = {
                          en: t('nav.english'),
                          fr: t('nav.french'),
                          // ar: t('nav.arabic')
                        }

                        return (
                          <Box display='flex' alignItems='center' gap={1} >
                            <img
                              src={LanguageLOGO}
                              alt='Language Logo'
                              style={{
                                width: '20px',
                                height: '20px'
                              }}
                            />
                            {selected ? languageMap[selected] : t('nav.selectLanguage')}
                          </Box>
                        )
                      }}
                    >
                      <MenuItem value='en' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}>{t('nav.english')}</MenuItem>
                      <MenuItem value='fr' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}>{t('nav.french')}</MenuItem>
                      {/* <MenuItem value='ar' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}>Arabic</MenuItem> */}
                    </MuiSelect>
                  </FormControl>
                </ListItem>
              </List>
              <List>
                <ListItem>
                  <LoginButton
                    variant='outlined'
                    startIcon={<LoginRoundedIcon />}
                    scroll={scroll}
                    location={location}
                    onClick={handleClickOpen}
                  >
                    {t('nav.login')}
                  </LoginButton>
                </ListItem>
              </List>
              <List>
                <ListItem>
                  <LoginButton onClick={handleMenuClick} scroll={scroll} location={location} endIcon={<MenuIcon />}>
                    {t('nav.menu')}
                  </LoginButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                    sx={{
                      mt: 13,
                      ml: -3
                    }}
                  >
                    {/* <List
                    sx={{
                      width: 250,
                      backgroundColor: 'common.white',
                      padding: 0
                    }}
                  >
                    <ListItem
                      onClick={() => {
                        navigate('/landing-page')
                        handleMenuClose()
                      }}
                    >
                      <ListItemText primary='Home' />
                    </ListItem>
                    <ListItem onClick={handleCategoryClick}>
                      <ListItemText primary='All Categories' />
                      {openCategory ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openCategory} timeout='auto' unmountOnExit>
                      <List component='div' disablePadding>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='International Transportation' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Local Transportation' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Brokerage Services' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Port Agent Services' />
                        </ListItem>
                      </List>
                    </Collapse>
                    <ListItem onClick={handleServicesClick}>
                      <ListItemText primary='Customs Services' />
                      {openServices ? <ExpandLess /> : <ExpandMore />}
                    </ListItem>
                    <Collapse in={openServices} timeout='auto' unmountOnExit>
                      <List component='div' disablePadding>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Local Transportation' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Warehousing & Fulfillment' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='International Transportation' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Customs Services' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Brokerage Services' />
                        </ListItem>
                        <ListItem sx={{ pl: 4 }}>
                          <ListItemText primary='Port Services' />
                        </ListItem>
                      </List>
                    </Collapse>
                    <ListItem
                      onClick={() => {
                        navigate('/worldwide-directory')
                        handleMenuClose()
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText primary='Agent Directory' />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary='About Us' />
                    </ListItem>
                    <ListItem>
                      <ListItemText primary='Help' />
                    </ListItem>
                  </List> */}
                    <List
                      sx={{
                        width: 260,
                        backgroundColor: 'common.white',
                        padding: 0,
                      }}
                    >
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={() => setHoverHome(true)}
                        onMouseLeave={() => setHoverHome(false)}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/landing-page');
                          }, 0);
                        }}
                      >
                        <ListItemIcon>
                          <HomeIcon color={hoverHome ? '#FC5722' : '#8F9DAC'} />
                        </ListItemIcon>
                        <ListItemText
                          primary="Home"
                          primaryTypographyProps={{
                            sx: { color: hoverHome ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>

                      <ListItem
                        onClick={handleCategoryClick}
                        onMouseEnter={() => setHoverCategory(true)}
                        onMouseLeave={() => setHoverCategory(false)}
                        style={{ cursor: 'pointer' }}
                      >
                        <ListItemIcon>
                          <CategoriesIcon color={hoverCategory ? '#FC5722' : '#8F9DAC'} />
                        </ListItemIcon>
                        <ListItemText
                          primary="Categories"
                          primaryTypographyProps={{
                            sx: { color: hoverCategory ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                          }}
                        />
                        {openCategory ? <ExpandLess /> : <ExpandMore />}
                      </ListItem>
                      <Collapse in={openCategory} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding sx={{ paddingLeft: 9 }}>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/allServices');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="All Services"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/internationalTransport');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="International Transport"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/domesticTransportcitywide');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Domestic Transport CityWide"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/domesticTransportcitytocity');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Domestic Transport City to City"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/customsServices');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Customs Services"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/warehouseServices');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Warehouse Services"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>

                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/portAgencyServices');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Port Agency Services"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                          <ListItem
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              handleMenuClose();
                              setTimeout(() => {
                                navigate('/categories/brokerageServices');
                              }, 0);
                            }}
                          >
                            <ListItemText
                              primary="Brokerage Services"
                              primaryTypographyProps={{
                                sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                              }}
                            />
                          </ListItem>
                        </List>
                      </Collapse>

                      <ListItem
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/worldwide-directory');
                          }, 0);
                        }}
                        onMouseEnter={() => setHoverDirectory(true)}
                        onMouseLeave={() => setHoverDirectory(false)}
                        style={{ cursor: 'pointer' }}
                      >
                        <ListItemIcon>
                          <AgentDirectoryIcon color={hoverDirectory ? '#FC5722' : '#8F9DAC'} />
                        </ListItemIcon>
                        <ListItemText
                          primary="Agent Directory"
                          primaryTypographyProps={{
                            sx: { color: hoverDirectory ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>

                      <ListItem
                        onMouseEnter={() => setHoverHelp(true)}
                        onMouseLeave={() => setHoverHelp(false)}
                        style={{ cursor: 'pointer' }}
                      >
                        <ListItemIcon>
                          <HelpIcon color={hoverHelp ? '#FC5722' : '#8F9DAC'} />
                        </ListItemIcon>
                        <ListItemText
                          primary="Help"
                          primaryTypographyProps={{
                            sx: { color: hoverHelp ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                    </List>
                  </Menu>
                </ListItem>
              </List>
            </Box>
            <Box display={{ xs: 'flex', sm: 'flex', md: 'none' }} alignItems={'center'}>
              <IconButton onClick={handleDrawerOpen}>
                <MenuIcon sx={{ color: '#fff' }} fontSize='large' />
              </IconButton>
            </Box>
          </Box>
        </Toolbar>
        <Dialog
          open={open}
          onClose={() => handleClose()}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title' sx={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}>
            <Translations text={translation.translate('PublicLayoutAppBar.Login')} />
          </DialogTitle>

          <DialogActions sx={{ justifyContent: 'center' }}>
            <Button
              variant='contained'
              color='primary'
              target='_blank'
              onClick={() => handleClose('https://www.customer.oujat.com/login')}
              sx={{
                textDecoration: 'none',
                width: '100%'
              }}
            >
              <Translations text={translation.translate('PublicLayoutAppBar.Customer')} />
            </Button>
            <Button
              variant='contained'
              color='primary'
              target='_blank'
              onClick={() => handleClose('https://www.agent.oujat.com/login')}
              sx={{
                textDecoration: 'none',
                width: '100%'
              }}
            >
              <Translations text={translation.translate('PublicLayoutAppBar.Agent')} />
            </Button>
          </DialogActions>
        </Dialog>
        <Drawer
          sx={{
            width: 260,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: 260,
              padding: '0 10px'
            }
          }}
          variant='persistent'
          anchor='right'
          open={openDrawer}
        >
          <DrawerHeaderWrapper>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? (
                <ChevronLeftIcon sx={{ color: '#0D1E32' }} />
              ) : (
                <ChevronRightIcon sx={{ color: '#0D1E32' }} />
              )}
            </IconButton>
          </DrawerHeaderWrapper>

          {/* Mobile Drawer Content */}
          <List>
            {/* Become an Agent dropdown in mobile */}
            <ListItem>
              <FormControl fullWidth sx={{ border: 'none' }}>
                <Select
                  value={agent}
                  onChange={handleChangeAgent}
                  defaultValue='Become an Agent'
                  sx={{
                    color: '#8F9DAC',
                    fontWeight: 700,
                    fontSize: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #E5E7EB',
                      borderRadius: '5px'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        maxHeight: 200
                      }
                    }
                  }}
                >
                  <StyledMenuItem
                    value={'Become an Agent'}
                    sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '16px' }}
                    onMouseEnter={() => setHoverAgent(true)}
                    onMouseLeave={() => setHoverAgent(false)}
                    onClick={() => window.open('https://www.agent.oujat.com/login', '_blank', 'noopener,noreferrer')}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <BecomeAnAgentIcon sx={{ fontSize: '20px', color: hoverAgent ? "#FC5722" : "#8F9DAC" }}/> */}
                      <Translations text={translation.translate('PublicLayoutAppBar.Become an Agent')} />
                    </Box>
                  </StyledMenuItem>

                  <StyledMenuItem
                    value={'Register/Login'}
                    sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '16px' }}
                    onMouseEnter={() => setHoverRegister(true)}
                    onMouseLeave={() => setHoverRegister(false)}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <RegisterLoginIcon sx={{ fontSize: '20px', color: hoverRegister ? "#FC5722" : "#8F9DAC" }}/> */}
                      <Translations text={translation.translate('PublicLayoutAppBar.Register/Login')} />
                    </Box>
                  </StyledMenuItem>

                  <StyledMenuItem
                    value={'Subscription Packages'}
                    sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '16px' }}
                    onMouseEnter={() => setHoverSubscription(true)}
                    onMouseLeave={() => setHoverSubscription(false)}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <SubscriptionIcon sx={{ fontSize: '20px', color: hoverSubscription ? "#FC5722" : "#8F9DAC" }}/> */}
                      <Translations text={translation.translate('PublicLayoutAppBar.Subscription Packages')} />
                    </Box>
                  </StyledMenuItem>

                  <StyledMenuItem
                    value={'How It Works'}
                    sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '16px' }}
                    onMouseEnter={() => setHoverHow(true)}
                    onMouseLeave={() => setHoverHow(false)}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {/* <HowItWorksIcon sx={{ fontSize: '20px', color: hoverHow ? "#FC5722" : "#8F9DAC" }}/> */}
                      <Translations text={translation.translate('PublicLayoutAppBar.How It Works')} />
                    </Box>
                  </StyledMenuItem>
                </Select>
              </FormControl>
            </ListItem>
            <ListItem>
              <FormControl fullWidth sx={{ border: 'none' }}>
                <Select
                  value={currency}
                  onChange={handleChangeCurrency}
                  displayEmpty
                  sx={{
                    color: '#8F9DAC',
                    fontWeight: 700,
                    fontSize: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #E5E7EB',
                      borderRadius: '5px'
                    }
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200
                      }
                    }
                  }}
                >
                  {currencyList.map((code) => (
                    <StyledMenuItem
                      key={code}
                      value={code}
                      sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '16px' }}
                    >
                      {code}
                    </StyledMenuItem>
                  ))}
                </Select>
              </FormControl>
            </ListItem>
            <ListItem>
              <FormControl fullWidth sx={{ border: 'none' }}>
                <Select
                  scroll={scroll}
                  location={location}
                  value={i18n.language}
                  onChange={event => {
                    const lang = event.target.value;
                    i18n.changeLanguage(lang);
                    if (lang === 'ar') {
                      saveSettings({ ...settings, direction: 'rtl' });
                    } else {
                      saveSettings({ ...settings, direction: 'ltr' });
                    }
                  }}
                  displayEmpty
                  renderValue={selected => {
                    const languageMap = {
                      en: t('nav.english'),
                      fr: t('nav.french'),
                      // ar: t('nav.arabic')
                    };

                    return (
                      <Box display='flex' alignItems='center' gap={1}>
                        {selected ? languageMap[selected] : t('nav.selectLanguage')}
                      </Box>
                    );
                  }}
                  sx={{
                    color: '#8F9DAC',
                    fontWeight: 700,
                    fontSize: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: '1px solid #E5E7EB',
                      borderRadius: '5px'
                    }
                  }}
                >
                  <MenuItem value='en' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}>{t('nav.english')}</MenuItem>
                  <MenuItem value='fr' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}>{t('nav.french')}</MenuItem>
                  {/* <MenuItem value='ar' sx={{ color: "#8F9DAC", fontWeight: 700, fontSize: '18px' }}> Arabic </MenuItem> */}
                </Select>
              </FormControl>
            </ListItem>
            <ListItem>
              <Button
                fullWidth
                variant='outlined'
                startIcon={<LoginRoundedIcon />}
                scroll={scroll}
                location={location}
                onClick={handleClickOpen}
              >
                <Translations text={translation.translate('PublicLayoutAppBar.Login')} />
              </Button>
            </ListItem>
            <ListItem>
              <Button
                fullWidth
                variant='outlined'
                onClick={handleMenuClick}
                scroll={scroll}
                location={location}
                endIcon={<MenuIcon />}
              >
                <Translations text={translation.translate('PublicLayoutAppBar.Menu')} />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                sx={{
                  mt: 13,
                  ml: -3
                }}
              >
                <List
                  sx={{
                    width: 260,
                    backgroundColor: 'common.white',
                    padding: 0,
                  }}
                >
                  <ListItem
                    style={{ cursor: 'pointer' }}
                    onMouseEnter={() => setHoverHome(true)}
                    onMouseLeave={() => setHoverHome(false)}
                    onClick={() => {
                      handleMenuClose();
                      setTimeout(() => {
                        navigate('/landing-page');
                      }, 0);
                    }}
                  >
                    <ListItemIcon>
                      <HomeIcon color={hoverHome ? '#FC5722' : '#8F9DAC'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={translation.translate('PublicLayoutAppBar.Categories.Home')}
                      primaryTypographyProps={{
                        sx: { color: hoverHome ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                      }}
                    />
                  </ListItem>

                  <ListItem
                    onClick={handleCategoryClick}
                    onMouseEnter={() => setHoverCategory(true)}
                    onMouseLeave={() => setHoverCategory(false)}
                    style={{ cursor: 'pointer' }}
                  >
                    <ListItemIcon>
                      <CategoriesIcon color={hoverCategory ? '#FC5722' : '#8F9DAC'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={translation.translate('PublicLayoutAppBar.Categories.title')}
                      primaryTypographyProps={{
                        sx: { color: hoverCategory ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                      }}
                    />
                    {openCategory ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={openCategory} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{ paddingLeft: 9 }}>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/allServices');
                          }, 0);
                        }}
                      >
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.subtitle')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/internationalTransport');
                          }, 0);
                        }}
                      >
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories1')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/domesticTransportcitywide');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories2')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/domesticTransportcitytocity');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories3')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/customsServices');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories4')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/warehouseServices');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories5')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>

                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/portAgencyServices');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories6')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                      <ListItem
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          handleMenuClose();
                          setTimeout(() => {
                            navigate('/categories/brokerageServices');
                          }, 0);
                        }}>
                        <ListItemText
                          primary={translation.translate('PublicLayoutAppBar.Categories.Categories7')}
                          primaryTypographyProps={{
                            sx: { color: '#8F9DAC', fontSize: '16px', fontWeight: 700 },
                          }}
                        />
                      </ListItem>
                    </List>
                  </Collapse>

                  <ListItem
                    onClick={() => {
                      handleMenuClose();
                      setTimeout(() => {
                        navigate('/worldwide-directory');
                      }, 0);
                    }}
                    onMouseEnter={() => setHoverDirectory(true)}
                    onMouseLeave={() => setHoverDirectory(false)}
                    style={{ cursor: 'pointer' }}
                  >
                    <ListItemIcon>
                      <AgentDirectoryIcon color={hoverDirectory ? '#FC5722' : '#8F9DAC'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={translation.translate('PublicLayoutAppBar.Agent Directory')}
                      primaryTypographyProps={{
                        sx: { color: hoverDirectory ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                      }}
                    />
                  </ListItem>

                  <ListItem
                    onMouseEnter={() => setHoverHelp(true)}
                    onMouseLeave={() => setHoverHelp(false)}
                    style={{ cursor: 'pointer' }}
                  >
                    <ListItemIcon>
                      <HelpIcon color={hoverHelp ? '#FC5722' : '#8F9DAC'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={translation.translate('PublicLayoutAppBar.Help')}
                      primaryTypographyProps={{
                        sx: { color: hoverHelp ? '#000' : '#8F9DAC', fontSize: '18px', fontWeight: 700 },
                      }}
                    />
                  </ListItem>
                </List>
              </Menu>
            </ListItem>
          </List>
        </Drawer>
      </AppBarWrapper>
    </>
  )
}

export default PublicLayoutAppBar